import { Box } from '@gousto-internal/citrus-react'
import React from 'react'

import type { Recipe } from '@library/menu-service'
import { LandingPageContent } from '../../landing-page-content/src/LandingPageContent'
import { LandingPageAboveTheFold } from '../../landing-page-above-the-fold/src/LandingPageAboveTheFold'
import { HowItWorksSection } from '@library/landing-pages'

export type HomepageProps = {
  onSignupCTAClick: () => void
  signupCTA: string
  recipes: Recipe[]
}

export function Homepage({ signupCTA, onSignupCTAClick, recipes }: HomepageProps) {
  return (
    <Box data-testid="homepage">
      <LandingPageAboveTheFold onCTAClick={onSignupCTAClick} signupCTA={signupCTA} />
      <HowItWorksSection signupCTA={signupCTA} onCTAClick={onSignupCTAClick} />
      <LandingPageContent
        onSignupCTAClick={onSignupCTAClick}
        recipes={recipes}
        signupCTA={signupCTA}
      />
    </Box>
  )
}
